<template>
  <div class="row event-row m-0 p-3">
    <div class="col-6 col-md-2 event-row-entry"><span class="d-md-none text-muted">Event Name<br></span>{{ event.name }}</div>
    <div class="col-6 col-md-2 text-end text-md-start event-row-entry"><span class="d-md-none text-muted">Datum<br></span>{{ event.date_from }}</div>
    <div class="col-12 col-md-4 pt-2 pt-md-0 event-row-entry">
      <span class="d-md-none text-muted">Kategorie<br></span>
      <select class="form-control w-100" v-model="selected_tt" v-if="!eventInCart && !cartFull">
        <option selected disabled value="false">Bitte wählen ...</option>
        <option v-for="tt in selectableTT" v-bind:key="tt.id" :value="tt.id">{{ tt.shopname }}</option>
      </select>
      <span v-else-if="eventInCart">{{ eventTickettypeInCart }}</span>
    </div>
    <div class="col-12 col-md-4 pt-2 pt-md-0 text-end event-row-entry">
      <div class="d-grid gap-2 d-md-block">
        <button class="btn btn-secondary" :disabled="!to_cart_allowed" @click="add_to_cart">
          <span v-if="cartFull">
            Es können keine weiteren Tickets bestellt werden.
          </span>
          <span v-else-if="eventInCart">
            Event bereits im Warenkorb
          </span>
          <span v-else-if="!selected_tt || getSelectedTicketType().freeContingent > 0">
            <img src="icon-cart.svg" class="cart-icon" alt="Cart Icon">
          </span>
          <span v-else>
            Ausverkauft
          </span>
        </button>
      </div>
    </div>
    <component v-bind:is="currentTabComponent" :event="event" :tickettype="getSelectedTicketType()" v-on:seatPlanClosed="currentTabComponent = null"></component>
  </div>
</template>

<script>
// eslint-disable-next-line no-undef
var _cart = cart;
var mttEvent = mttEvent;

export default {
  name: "EventTableRow",
  props: ['event'],
  data: function () {
    return {
      selected_tt: false,
      cart: _cart,
      currentTabComponent: null
    }
  },
  computed: {
    to_cart_allowed: function () {
      if(this.selected_tt && this.getSelectedTicketType().freeContingent <= 0) {
        return false;
      }
      if(this.eventInCart) {
        return false;
      }
      if(this.selected_tt && this.selectableTT.some(tt => tt.id == this.selected_tt) && !this.cartFull) {
        return true;
      }
      return false;
    },
    eventInCart: function () {
      if(this.cart.cartEntries.filter(ce => ce.event.id == this.event.id).length >= 1) {
        return true;
      }
      return false;
    },
    eventTickettypeInCart: function () {
      let inCartEvent = this.cart.cartEntries.filter(ce => ce.event.id == this.event.id)
      if(inCartEvent.length >= 1) {
        return inCartEvent[0].ticket.shopname;
      }
      return '';
    },
    cartFull: function () {
      if(this.cart.cartEntries.length > 0) {
        if(this.cart.cartEntries[0].ticket.shopname === "3er Wahlabo") {
          return this.cart.cartEntries.length >= 3
        } else if(this.cart.cartEntries[0].ticket.shopname === "5er Wahlabo") {
          return this.cart.cartEntries.length >= 5
        }
      }
      return this.cart.cartEntries.length >= 3
    },
    selectableTT: function () {
      if(this.cart.cartEntries.length > 0) {
        return this.event.tickettypes_selectable.filter(tt => tt.shopname == this.cart.cartEntries[0].ticket.shopname)
      }
      return this.event.tickettypes_selectable;
    }
  },
  methods: {
    add_to_cart: function () {
      var event = Object.assign({}, this.event);
      mttEvent = event;
      delete event['tickettypes'];
      var tickettype = this.getSelectedTicketType()
      tickettype.quantity = 1;
      _cart.addToCart(event, tickettype, 1, [], true);
    },
    getSelectedTicketType: function() {
      return Object.assign([], this.event.tickettypes).filter(tt => tt.id == this.selected_tt)[0]
    }
  }
}
</script>

<style scoped>
.cart-icon {
  height: 22px;
}

</style>